import React from "react";

const IconTask = (props) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <ellipse
        cx={12.9863}
        cy={17.4924}
        rx={7}
        ry={3.5}
        stroke={props.color || "#1C1C2C"}
        strokeWidth={1.3}
        strokeLinejoin="round"
      />
      <circle
        cx={12.9863}
        cy={6.99243}
        r={4}
        stroke={props.color || "#1C1C2C"}
        strokeWidth={1.3}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconTask;
